<template>
  <vs-card>
    <vs-row
      style="padding-bottom: 30px"
    >
      <vs-col
        vs-type="flex"
        vs-justify="end"
        vs-align="left"
        vs-w="12"
        v-can="permissions.add"
      >
        <vs-button
          icon-pack="feather"
          icon="icon-plus"
          class="mr-4"
          @click="createCampaign"
        >
          إضافة حملة جديدة
        </vs-button>
      </vs-col>
    </vs-row>
    <vs-row>
      <vs-col
        vs-lg="4"
        vs-sm="8"
        vs-xs="12"
        class="p-1"
        v-for="campaign in campaigns"
        :key="campaign.id"
      >
        <tm-card
          :title="campaign.name"
          :img="campaign.images[0]"
          :link="`/donations/campaignsDetails/${campaign.programId}/${campaign.id}`"
          :complete-percentage="campaign.completePercentage"
        />
      </vs-col>
    </vs-row>
    <store-popup
      :campaign="campaign"
      title="إضافة حملة"
      ref="storePopupRef"
      @created="campaignCreated"
    />
  </vs-card>
</template>

<script>
import TmCard from "@/app/donations-website/components/TmCard.vue";
import StorePopup from './campaignsPopup.vue';
import {RepositoryFactory} from "../../donations-repositories/donationsRepositoryFactory";
import utilities from "@/app/shared/utilities";

const campaignsRepo = RepositoryFactory.get("campaignsRepository");

export default {
  name: "Campaigns",
  components: {
    TmCard,
    StorePopup
  },
  data() {
    return {
      campaigns: [],
      index: 0,
      isLoading: true,
      campaign: {
        id: null,
        programId: this.$route.params.id,
        name: '',
        description: '',
        location: '',
        status: '',
        beneficiariesNumber: '',
        targetAmount: '',
        collectedAmount: '',
        completePercentage: '',
        remainingAmount: '',
        finishedAt: '',
        images: [],
        order: '',
        costPerUnit: null,
      },
      permissions: {
        add: "store_campaigns",
        update: "update_campaigns",
        delete: "destory_campaigns"
      }
    };
  },
  methods: {
    redirect(route) {
      this.$router.push({name: route});
    },
    async fetchAllCampaigns() {
      this.campaigns = await campaignsRepo.fetchAllCampaigns(this.$route.params.id);
      this.isLoading = false;
    },
    createCampaign() {
      utilities.initObjectMembers(this.campaign);
      this.$refs.storePopupRef.open();
    },
    campaignCreated(campaign) {
      this.campaigns.push(campaign);
    },
  },
  async created() {
    await this.fetchAllCampaigns();
  },
};
</script>

<style scoped>
.vs-switch-primary {
  background: #d94d4d;
}
</style>
